import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { CablePlanDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchCablePlans } from "../../../../features/auth/store/cablePlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import CablePlans from "./Cable";
import { fetchCableCategories } from "../../../../features/auth/store/cableCategorySlice";
import { SortBy, SortOrder } from "../../../../features/auth/store/types/types";
import { fetchCountries } from "../../../../features/auth/store/countrySlice";

const CablePlanRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [categoryFilter, setCategoryFilter] = useState<string>("");
  const [countryFilter, setCountryFilter] = useState<string>("");
  const [sortBy, setSortBy] = useState<SortBy | "">("created_at");
  const [sortOrder, setSortOrder] = useState<SortOrder | "">("desc");
  const [selectedCablePlan, setSelectedCablePlan] = useState<Product | null>(
    null,
  );
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { cablePlans, loading, error } = useSelector(
    (state: RootState) => state.cablePlans,
  );

  const { cableCategories } = useSelector(
    (state: RootState) => state.cableCategories,
  );

  const isMounted = useRef(false);

  useEffect(() => {
    if (!cableCategories || cableCategories.length == 0) {
      dispatch(fetchCableCategories({ perPage: 100 }));
    }
    dispatch(fetchCountries({ page: 1, perPage: 100 }));
  }, []);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      dispatch(fetchCablePlans({}));
      return;
    }
    const handler = setTimeout(() => {
      const filters: Record<string, any> = {};

      if (statusFilter) filters.status = statusFilter;
      if (categoryFilter) filters.category = categoryFilter; // ID sent
      if (countryFilter) filters.country = countryFilter; // ID sent
      if (sortBy) filters.sort_by = sortBy;
      if (sortOrder) filters.sort_order = sortOrder;
      if (searchTerm.trim()) filters.search = searchTerm.trim();

      dispatch(fetchCablePlans(filters));
    }, 350);

    return () => clearTimeout(handler);
  }, [
    dispatch,
    statusFilter,
    categoryFilter,
    countryFilter,
    sortBy,
    sortOrder,
    searchTerm,
  ]);

  // Transform DataPlan to Product - ensuring all required fields are present

  const handleCablePlanClick = (dataPlan: Product) => {
    setSelectedCablePlan(dataPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedCablePlan(null);
  };

  if (showDetailView && selectedCablePlan) {
    return (
      // <ProductDetailView dataPlan={selectedDataPlan} onBack={handleBackToList} />
      <CablePlanDetailView
        cablePlan={{
          ...selectedCablePlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <CablePlans
      cablePlans={cablePlans || []}
      loading={loading}
      error={error}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onCablePlanClick={handleCablePlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      categoryFilter={categoryFilter}
      setCategoryFilter={setCategoryFilter}
      countryFilter={countryFilter}
      setCountryFilter={setCountryFilter}
      sortBy={sortBy}
      setSortBy={setSortBy}
      sortOrder={sortOrder}
      setSortOrder={setSortOrder}
    />
  );
};

export default CablePlanRouter;
